import { useCallback, useEffect } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import WorkflowTypeSelect from 'automation-ui-enrollment/components/workflowType/WorkflowTypeSelect';
import EnrollmentSchedule from 'automation-ui-enrollment/records/EnrollmentSchedule';
import EnrollmentScheduleSelect from 'automation-ui-enrollment/components/scheduledEnrollment/EnrollmentScheduleSelect';
import TriggerGroupContainer from 'automation-ui-enrollment/components/common/TriggerGroupContainer';
import { applyScheduledTriggersToFlow } from 'automation-ui-canvas/create/utils/applyTriggers';
import { OBJECTLESS_WORKFLOWS } from 'automation-ui-canvas/constants/Gates';
import { useIsUngated } from 'automation-ui-core/hooks/authHooks';
import I18n from 'I18n';
import { UNKNOWN_ID } from 'automation-ui-references/object-types/CRMObjectTypes';
import PortalIdParser from 'PortalIdParser';
import { ONCE } from 'automation-ui-enrollment/constants/scheduledEnrollment/ScheduleCadence';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default function ScheduledTriggerStep({
  objectTypeId,
  flow,
  setFlow,
  setValidationMessage,
  setObjectTypeId
}) {
  const isUngatedForObjectlessWorkflows = useIsUngated(OBJECTLESS_WORKFLOWS);
  const enrollmentSchedule = new EnrollmentSchedule(flow.enrollmentSchedule);
  const isValid = objectTypeId !== UNKNOWN_ID || isUngatedForObjectlessWorkflows;
  useEffect(() => {
    setValidationMessage(isValid ? null : I18n.text('createWorkflow.selectRequiredObjectTypeTooltip'));
  }, [isValid, setValidationMessage]);
  const handleChange = useCallback(({
    target: {
      value: newEnrollmentSchedule
    }
  }) => {
    setValidationMessage(newEnrollmentSchedule.getValidationResult().errorMessage);
    setFlow(draftFlow => {
      applyScheduledTriggersToFlow(newEnrollmentSchedule, draftFlow);
    });
  }, [setFlow, setValidationMessage]);
  const setScheduledTriggerObjectTypeId = useCallback(newObjectTypeId => {
    setObjectTypeId(newObjectTypeId);
    setFlow(draftFlow => {
      var _draftFlow$enrollment;
      applyScheduledTriggersToFlow((_draftFlow$enrollment = draftFlow.enrollmentSchedule) !== null && _draftFlow$enrollment !== void 0 ? _draftFlow$enrollment : EnrollmentSchedule.getDefaultScheduleForPortal(PortalIdParser.get()).setCadence(ONCE), draftFlow);
    });
  }, [setFlow, setObjectTypeId]);
  const isEnrollmentScheduleDisabled = !isUngatedForObjectlessWorkflows && objectTypeId === UNKNOWN_ID;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Text, {
      as: "h5",
      marginBlockEnd: "300",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "createWorkflow.startTriggerHeader"
      })
    }), /*#__PURE__*/_jsxs(TriggerGroupContainer, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "createWorkflow.triggerOptions.scheduled.groupHeading"
      }),
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h6",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "createWorkflow.triggerOptions.scheduled.title"
        })
      }), /*#__PURE__*/_jsx(WorkflowTypeSelect, {
        objectTypeFilter: isUngatedForObjectlessWorkflows ? () => true : undefined,
        objectTypeId: objectTypeId,
        onChange: setScheduledTriggerObjectTypeId,
        formControlProps: {
          label: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "createWorkflow.triggerOptions.scheduled.objectTypeSelectLabel"
          }),
          required: !isUngatedForObjectlessWorkflows
        },
        placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "createWorkflow.objectSelectPlaceholder"
        })
      }), /*#__PURE__*/_jsx(UITooltip, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "createWorkflow.triggerOptions.scheduled.disabledTooltip"
        }),
        placement: "right",
        disabled: !isEnrollmentScheduleDisabled,
        children: /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(EnrollmentScheduleSelect, {
            schedule: enrollmentSchedule,
            onChange: handleChange,
            readOnly: isEnrollmentScheduleDisabled
          })
        })
      })]
    })]
  });
}
export const scheduledTriggerStep = {
  component: ScheduledTriggerStep,
  getLabel: () => I18n.text('createWorkflow.step.selectTrigger')
};